{
  "assetContainerEvent": {
    "types": {
      "arrived": "到着済み",
      "arrivedWaiting": "到着済み／待機中",
      "loading": "積み込み中",
      "loadingComplete": "積み込み完了",
      "unloading": "荷降ろし中",
      "unloadingComplete": "荷降ろし完了",
      "readyForPickup": "引き取り準備完了",
      "departed": "出発済み",
      "inoperable": "使用不可",
      "missing": "所在不明",
      "inTransit": "移動中"
    }
  },
  "assetVisitYardEvent": {
    "Arrived": "到着",
    "Docked": "ドック着け",
    "Parked": "駐車",
    "Unassigned": "割り当て解除",
    "Dropped": "切り離し",
    "Hooked": "連結",
    "Appointment Linked": "予約をリンク",
    "Appointment Unlinked": "予約のリンクを解除",
    "Status Updated": "ステータス更新"
  },
  "assetContainerTypes": {
    "trailer": "トレーラー",
    "container": "コンテナ",
    "oversized": "特大",
    "chassis": "シャーシ",
    "reefer": "冷凍トレーラー",
    "other": "その他"
  },
  "assetVisitTypes": {
    "live": "ライブ荷役",
    "drop": "ドロップ（切り離し）",
    "pickup": "フック（連結）",
    "dropHook": "ドロップ＆フック"
  },
  "assetVisitDirections": {
    "inbound": "入荷",
    "outbound": "出荷",
    "inboundAndOutbound": "入荷・出荷"
  },
  "loadTypeDirections": {
    "inbound": "入荷",
    "outbound": "出荷",
    "inOut": "入荷／出荷"
  },
  "altAssetVisitTypes": {
    "unknown": "不明"
  },
  "assetContainerStates": {
    "full": "満載",
    "empty": "空",
    "partiallyLoaded": "一部積載"
  },
  "spotStatuses": {
    "open": "開放",
    "closed": "閉鎖",
    "assigned": "割り当て済み",
    "inTransit": "移動中",
    "reservedManual": "確保済み",
    "reservedAutomated": "確保済み",
    "unknown": "不明"
  },
  "spotTypes": {
    "parking": "駐車",
    "docking": "ドック"
  },
  "labels": {
    "licensePlate": "ナンバープレート",
    "dotNumber": "DOT 番号"
  },
  "messages": {
    "unknownCompany": "不明な会社",
    "unhooked": "未連結",
    "noInformationAvailable": "情報がありません",
    "noVisitFound": "訪問が見つかりません",
    "notInformed": "未入力",
    "waitingAssignment": "割り当て待ち",
    "failedToLoadSpotDetails": "スポットの詳細を読み込めませんでした",
    "retry": "再試行",
    "blockedUntilSpotIsOpen": "{spot} が開放されるまでブロック中",
    "blockReasons": {
      "reservedByOther": "移動先のスポットは **移動タスク #{taskNumber}** 用に **確保済み** です。",
      "reservedByOtherGeneric": "移動先のスポットは **確保済み** です。",
      "destinationClosed": "移動先のスポットは **閉鎖** されています。",
      "destinationOccupied": "移動先のスポットは別のアセットが **使用中** です。",
      "anotherAssetInTransitForDestination": "**{assetCode}** はすでにこのスポットへ移動中です。",
      "assetInTransitElsewhere": "このアセットは、すでに別の移動タスクで移動中です。"
    }
  }
}
